// extracted by mini-css-extract-plugin
export var arrows = "_3y-5";
export var decrementer = "_3y-9";
export var disabled = "_3y-3";
export var error = "_3y-1";
export var hiddenText = "_3y-a";
export var incrementer = "_3y-8";
export var input = "_3y-7";
export var inputWrapper = "_3y-0";
export var readonly = "_3y-2";
export var regular = "_3y-6";
export var small = "_3y-4";